export default __webpack_public_path__ + "static/media/zalo_ico.bdddeec6.svg";